import React from 'react';

import { useFormControlState } from '../useFormControlState/useFormControlState';

import { useTranslations } from 'shared/hooks';
import { StyledLabel } from './Label.styles';

export const Label: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { message } = useTranslations(children);
  const { disabled, required, id, hiddenLabel } = useFormControlState();

  if (hiddenLabel) {
    return null;
  }

  return (
    // @ts-expect-error - Material-UI v4 styled component type conflict with React 18
    <StyledLabel htmlFor={id} shrink required={required} disabled={disabled}>
      {message}
    </StyledLabel>
  );
};
